import { HeaderBar } from './header/bar';
import { HeaderNavigation } from './header/navigation';
import { Page } from './page';

/**
 * Model definition for header
 */
export interface Header {
  __contentType: 'header';
  id: string;
  name?: string;
  pages?: Page[];
  content?: (HeaderBar | HeaderNavigation)[];
}

export function isHeader(obj: { __contentType?: string }): obj is Header {
  return obj?.__contentType === 'header';
}
